/**
 * Numeric limits constants
 */

export const INT32_MAX = 2147483647;
export const INT32_MIN = -2147483648;

export const DEFAULT_TIME_DATE = '2000-01-10';

export const DEFAULT_MAX_RESULT_COUNT = 20;
export const MAX_PAGE_SIZE = 1000;
export const DEFAULT_TOASTER_LIFE = 5000;

export const DEFAULT_TEXTAREA_MAX_LENGTH = 200;